const superAdminSidebarData = [
    {
        label: "Dashboard",
        isMainMenu: true,
    },
    {
        label: "Dashboard",
        icon: "mdi mdi-home-variant-outline",
        url: "/dashboard",
        isHasArrow: true,
    },
    {
        label: "Organization",
        isMainMenu: true,
    },
    {
        label: "Organization List",
        icon: "mdi mdi-factory",
        isHasArrow: true,
        url: "/orglist",
    },
    {
        label: "Users",
        isMainMenu: true,
    },
    {
        label: "Users List",
        icon: "mdi mdi-account",
        isHasArrow: true,
        url: "/userlist",
    },
    {
        label: "Devices",
        isMainMenu: true,
    },
    {
        label: "Devices List",
        icon: "mdi mdi-deskphone",
        isHasArrow: true,
        url: "/devicelist",
    },
    {
        label: "Others",
        isMainMenu: true,
    },
    {
        label: "Products",
        icon: "mdi mdi-coach-lamp",
        isHasArrow: true,
        url: "/productlist",
    },
    {
        label: "Zones",
        icon: "mdi mdi-access-point",
        isHasArrow: true,
        url: "/zonelist",
    },
    {
        label: "My Approvals",
        icon: "mdi mdi-checkbox-marked",
        isHasArrow: true,
        issubMenubadge: true,
        bgcolor: "primary",
        url: "/approvallist",
    },
    {
        label: "My Requests",
        icon: "mdi mdi-progress-upload",
        isHasArrow: true,
        issubMenubadge: true,
        url: "/requestlist",
    },
    {
        label: "App Versions",
        icon: "mdi mdi-apps",
        isHasArrow: true,
        issubMenubadge: false,
        url: "/appversionlist",
    },
    {
        label: "Settings",
        isMainMenu: true,
    },
    {
        label: "Return Reason",
        icon: "mdi mdi-cog",
        isHasArrow: true,
        url: "/settings/returnreason",
    },
]

const adminSidebarData = [
    {
        label: "Dashboard",
        isMainMenu: true,
    },
    {
        label: "Dashboard",
        icon: "mdi mdi-home-variant-outline",
        url: "/dashboard",
        isHasArrow: true,
    },
    {
        label: "Users",
        isMainMenu: true,
    },
    {
        label: "Users List",
        icon: "mdi mdi-account",
        isHasArrow: true,
        url: "/userlist",
    },
    {
        label: "Devices",
        isMainMenu: true,
    },
    {
        label: "Devices List",
        icon: "mdi mdi-deskphone",
        isHasArrow: true,
        url: "/devicelist",
    },
    {
        label: "Return Approval",
        icon: "mdi mdi-cart-check",
        isHasArrow: true,
        issubMenubadge: true,
        url: "/returnapproval",
    },
    {
        label: "Return Request",
        icon: "mdi mdi-cart-arrow-down",
        isHasArrow: true,
        url: "/returnrequest",
    },
    {
        label: "Others",
        isMainMenu: true,
    },
    // {
    //     label: "Products",
    //     icon: "mdi mdi-coach-lamp",
    //     isHasArrow: true,
    //     url: "/productlist",
    // },
    {
        label: "Zones",
        icon: "mdi mdi-access-point",
        isHasArrow: true,
        url: "/zonelist",
    },
    {
        label: "My Approvals",
        icon: "mdi mdi-checkbox-marked",
        isHasArrow: true,
        issubMenubadge: true,
        url: "/approvallist",
    },
    // {
    //     label: "My Requests",
    //     icon: "mdi mdi-progress-upload",
    //     issubMenubadge: true,
    //     isHasArrow: true,
    //     url: "/requestlist",
    // },
]

const manufacturerSidebarData = [
    {
        label: "Dashboard",
        isMainMenu: true,
    },
    {
        label: "Dashboard",
        icon: "mdi mdi-home-variant-outline",
        url: "/dashboard",
        isHasArrow: true,
    },
    {
        label: "Devices",
        isMainMenu: true,
    },
    {
        label: "Devices List",
        icon: "mdi mdi-deskphone",
        isHasArrow: true,
        url: "/devicelist",
    },
    {
        label: "Return Approval",
        icon: "mdi mdi-cart-check",
        isHasArrow: true,
        issubMenubadge: true,
        url: "/returnapproval",
    },
    {
        label: "Others",
        isMainMenu: true,
    },
    {
        label: "Products",
        icon: "mdi mdi-coach-lamp",
        isHasArrow: true,
        url: "/productlist",
    },
]

const nonCustomerSidebarData = [
    {
        label: "Dashboard",
        isMainMenu: true,
    },
    {
        label: "Dashboard",
        icon: "mdi mdi-home-variant-outline",
        url: "/dashboard",
        isHasArrow: true,
    },
    {
        label: "Users",
        isMainMenu: true,
    },
    {
        label: "Users List",
        icon: "mdi mdi-account",
        isHasArrow: true,
        url: "/userlist",
    },
    {
        label: "Devices",
        isMainMenu: true,
    },
    {
        label: "Devices List",
        icon: "mdi mdi-deskphone",
        isHasArrow: true,
        url: "/devicelist",
    },
    {
        label: "Return Approval",
        icon: "mdi mdi-cart-check",
        isHasArrow: true,
        issubMenubadge: true,
        url: "/returnapproval",
    },
    {
        label: "Return Request",
        icon: "mdi mdi-cart-arrow-down",
        isHasArrow: true,
        url: "/returnrequest",
    },
    {
        label: "Others",
        isMainMenu: true,
    },
    {
        label: "My Requests",
        icon: "mdi mdi-progress-upload",
        isHasArrow: true,
        issubMenubadge: true,
        url: "/requestlist",
    },

]
const customerSidebarData = [
    {
        label: "Dashboard",
        isMainMenu: true,
    },
    {
        label: "Dashboard",
        icon: "mdi mdi-home-variant-outline",
        url: "/dashboard",
        isHasArrow: true,
    },
    {
        label: "Devices",
        isMainMenu: true,
    },
    {
        label: "Devices List",
        icon: "mdi mdi-deskphone",
        isHasArrow: true,
        url: "/devicelist",
    },
    {
        label: "Return Request",
        icon: "mdi mdi-cart-arrow-down",
        isHasArrow: true,
        url: "/returnrequest",
    },
]

export {
    superAdminSidebarData,
    adminSidebarData,
    nonCustomerSidebarData,
    customerSidebarData,
    manufacturerSidebarData
};